import React from 'react';
import { Box, CircularProgress, Dialog, Divider, Grid, Stack, Tooltip, Typography } from '@mui/material';
import styles from 'custom/style.module.css';
import manifestStyles from './manifest.module.css';
import { CustomButton, CustomDialogTitle, CustomDialogAction, CustomDialogContent } from 'custom/components';
// import { CloseIconBtn } from 'custom/constants';
import cookies from 'utils/cookies';

const FfmModal = (props) => {
  const verifyFfm = () => {
    let stn = cookies.get('station_code');

    if (props.ffm?.dest === stn) {
      if (props.ffm?.in_ffm && props.ffm.in_ffm.processing === false && props.ffm.in_ffm.verify === 1) {
        return true;
      }
    } else {
      console.log('out ffm', props.ffm?.out_ffm);
      if (props.ffm?.out_ffm && props.ffm.out_ffm.processing === false && props.ffm.out_ffm.verify === 1) {
        return true;
      }
    }

    return false; // Ensure a boolean is always returned
  };
  const getawbCount = (ulds) => {
    let awbs = [];
    ulds?.forEach(uld => {
      uld?.flight_awbs?.forEach(awb => {
        if (!awbs.includes(awb.awb_no)) {
          awbs.push(awb.awb_no);
        }
      });
    });
    return awbs.length;
  };

  const getProgressColor = (score) => {
    switch (true) {
      case score < 90:
        return {
          color: 'error',
          message: 'Review required.' 
        };
      case score >= 90 && score < 100:
        return {
          color: 'warning',
          message: 'Review recommended.' 
        };
      case score === 100:
        return {
          color: 'secondary',
          message: 'Perfect Score.' 
        };
      default:
        return {
          color: 'primary',
          message: 'Looks good.' 
        };
    }
  };

  return (
    <div>
      <Dialog
        aria-labelledby='form-dialog-title'
        open={verifyFfm()} // Call the function and use its return value
        onClose={props.onClose}
      >
        <CustomDialogTitle id='form-dialog-title'>
          Manifest Details
          {/* <CloseIconBtn onClick={props.onClose} /> */}
        </CustomDialogTitle>
        <CustomDialogContent sx={{ width: 600 }}>
          <Stack direction='row' alignItems='center' justifyContent='space-evenly' spacing={1} mb={3}>
            <Stack direction='column' alignItems='flex-start' justifyContent='center' spacing={1} mb={2}>
              <Stack direction='row' alignItems={'center'} mb={2}>
                <Typography variant='h6' component={'h6'} color='primary' textAlign={'center'}>Manifest Extraction Score
                </Typography>
                <Tooltip title='The extraction score indicates the accuracy of the manifest data based on our analysis. 
              A higher score means the data is more likely to be correct, while a lower score suggests there may be discrepancies that require your attention. 
              Please review the manifest details carefully, especially if the extraction score is below 90%.' placement='top'>
                  <Typography component={'span'} className={manifestStyles.infoIcon}>i</Typography>
                </Tooltip>
              </Stack>
              <Stack direction='column' spacing={2}>
                <Stack direction='column' alignItems='start' justifyContent={'flex-start'}>
                  <Typography component='div' fontWeight={700} color='#4caf50' variant={'body2'}><Box component={'span'} sx={{
                    width: 8,
                    height: 8,
                    bgcolor: '#4caf50',
                    borderRadius: '50%',
                    display: 'inline-block',
                    mr: 1 
                  }} />High: <Typography variant='caption' component={'span'} color='primary' fontWeight={600}>100%</Typography></Typography>
                  <Typography variant='caption' component={'p'} color='text.secondary'>Manifest data is perfectly extracted.</Typography>
                </Stack>
                <Stack direction='column' alignItems='start' >
                  <Typography component='div' fontWeight={700} color='#ff9800' variant={'body2'}><Box component={'span'} sx={{
                    width: 8,
                    height: 8,
                    bgcolor: '#ff9800',
                    borderRadius: '50%',
                    display: 'inline-block',
                    mr: 1 
                  }} />Medium: <Typography variant='caption' component={'span'} color='primary' fontWeight={600}>90%-99%</Typography></Typography>
                  <Typography variant='caption' component={'p'} color='text.secondary'>Manifest data is mostly correct but may require review.</Typography>
                </Stack>
                <Stack direction='column' alignItems='start'>
                  <Typography component='div' fontWeight={700} color='#f44336' variant={'body2'}><Box component={'span'} sx={{
                    width: 8,      
                    height: 8,
                    bgcolor: '#f44336',
                    borderRadius: '50%',
                    display: 'inline-block',
                    mr: 1 
                  }} />Low: <Typography variant='caption' component={'span'} color='primary' fontWeight={600}> &lt; 90%</Typography></Typography>
                  <Typography variant='caption' component={'p'} color='text.secondary'>Manifest data requires review.</Typography>
                </Stack>
              </Stack>
            </Stack>
            <Box component={'div'}className={manifestStyles.progressWrapper}>
              <CircularProgress variant='determinate' 
                value={props.ffm?.docs?.data?.confidence_score || 0} 
                color={getProgressColor(props.ffm?.docs?.data?.confidence_score || 0).color}
                size={180}
                thickness={5}  />
              <Box component='div' className={manifestStyles.progressCount}>
                <Typography variant='h4' component={'h4'} color='primary' textAlign={'center'} fontWeight={600}>
                  {props.ffm?.docs?.data?.confidence_score ? `${props.ffm.docs.data.confidence_score}%` : 'N/A'}
                </Typography>
                <Typography variant='body2' component={'p'} fontWeight={600} 
                  color={getProgressColor(props.ffm?.docs?.data?.confidence_score || 0).color} textAlign={'center'}>
                  {getProgressColor(props.ffm?.docs?.data?.confidence_score || 0).message}
                </Typography>
              </Box>
            </Box>
          </Stack>
          {/* <Divider /> */}
          <Divider textAlign='center'>
            <Typography variant='body2' color='primary' fontWeight={600}>Verify the below manifest details</Typography>
          </Divider>
          <Box className={manifestStyles.detailsBox}>
            <Grid container spacing={3}>
              <Grid item xs>
                <Stack direction='row-reverse' alignItems='baseline' justifyContent='center' spacing={1} borderRight='2px solid var(--secondarygreen)' className={manifestStyles.detailsStack}>
                  <Typography variant='caption' textTransform='uppercase' fontWeight={700} color='text.disabled'>Ulds</Typography>
                  <Typography variant='h4' color='primary' fontWeight={600}>{props.ffm?.flight_uld?.filter(uld => !uld.is_bulk).length || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack direction='row-reverse' alignItems='baseline' justifyContent='center' spacing={1} borderRight='2px solid var(--secondarygreen)' className={manifestStyles.detailsStack}>
                  <Typography variant='caption' textTransform='uppercase' fontWeight={700} color='text.disabled'>Awbs</Typography>
                  <Typography variant='h4' color='primary' fontWeight={600}>
                    {/* {props.ffm?.flight_uld?.reduce(
                    (acc, curr) => acc + (curr.flight_awbs ? curr.flight_awbs.length : 0),
                    0
                  ) || 0} */}
                    {getawbCount(props.ffm?.flight_uld || []) || 0}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs='auto' minWidth={'33.33%'}>
                <Stack direction='row-reverse' alignItems='baseline' justifyContent='center' spacing={1} className={manifestStyles.detailsStack}>
                  <Typography variant='caption' textTransform='uppercase' fontWeight={700} color='text.disabled'>kgs wt</Typography>
                  <Typography variant='h4' color='primary' fontWeight={600}>{props.ffm?.flight_uld?.reduce(
                    (acc, curr) =>
                      acc +
                      (curr.flight_awbs
                        ? curr.flight_awbs.reduce((a, c) => a + parseFloat(c.wgt || 0), 0)
                        : 0),
                    0
                  )?.toFixed(2) || 0}{' '}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </CustomDialogContent>
        <CustomDialogAction className={`${styles.fSpaceBtw}`}>
          <CustomButton variant='contained' onClick={props.acceptFfm}>
            Accept
          </CustomButton>
          <CustomButton
            variant='contained'
            onClick={() => {
              document.getElementById('ffm-file').click();
            }}
          >
            Re-Upload
          </CustomButton>
        </CustomDialogAction>
      </Dialog>
    </div>
  );
};

export default FfmModal;